$( document ).on("turbo:load", function () {
  if ($('#content-modal').length > 0) {
    if ($('#newContent').length > 0) {
      $('[data-function="existing-content-list"]').hide();
      $('.filter-form').hide();
    } else {
      $('[data-function="new-content-list"]').hide();
      $('.filter-form').show();
    }
    $('input[data-function="new-content"]').click(function(e){
      $('[data-function="new-content-list"]').show();
      $('.filter-form').hide();
      $('[data-function="existing-content-list"]').hide();
    });
    $('input[data-function="existing-content"]').click(function(e){
      $('[data-function="existing-content-list"]').show();
      $('.filter-form').show();
      $('[data-function="new-content-list"]').hide();
    });
  }
})
